import api from '@pray/shared/utils/api';

import type { GetExperimentByIdResponse } from './types/api';

/**
 * Returns a single experiment
 * @param id - The id of the experiment
 * @param instanceName - Optional instance name for faster lookup (avoids N+1 queries)
 * @returns The experiment
 */
export async function getExperiment(id: string, instanceName?: string) {
  if (!id) throw new Error('Experiment ID is required');

  const url = `/web/studio/experiments/${id}`;
  const params: Record<string, string> = {};

  if (instanceName) {
    params.instance_name = instanceName;
  }

  const response = await api.executeGetRequest<GetExperimentByIdResponse>(url, params);

  return response.data;
}
